import api from 'Application/api/api';

const getProjectDefaults = signal =>
	api.get('/project-preferences', {
		signal,
	});

export default getProjectDefaults;
